import { SEO } from './page'
import { RichText } from './post'

const newsTab = 'Recent News'
const pressTab = 'Press Releases'

export const PressConstants = {
  newsTab,
  pressTab,
  pressPageTabs: [newsTab, pressTab],
  widgetTitle: 'Media Contact',
  socialTitle: 'Connect with us!',
  incrementValue: 6,
}

export interface NewsItem {
  id: string
  publishDate: string
  source: {
    name: string
  }
  title: string
  url: string
}

export interface PressItem {
  id: string
  publishedDate: string
  title: string
  slug: string
  brand: { name: string }
}

export interface InquiryWidget {
  contactName: string
  email: string
}

export interface TISEO {
  pageTitle: string
  description: {
    description: string
  }
  socialImage: {
    file: {
      url: string
    }
  }
}

interface ModifiedTISEO extends SEO {
  imageURL: string
}

export interface PressArticlePage {
  title: string
  inquiryWidget: {
    email: string
    contactName: string
  }
  body: RichText
  id: string
  contentful_id: string
  seo: TISEO
  updatedAt: string
  publishedDate: string
  brand: {
    name: string
  }
  slug: string
  canonicalUrl: string
}

export interface ModifiedPressArticlePage
  extends Omit<PressArticlePage, 'seo'> {
  seo: ModifiedTISEO
}
